// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';

export const INITIALIZE_ACCOUNT_ON_API = 'INITIALIZE_ACCOUNT_ON_API';
export const UPDATE_BUSINESS_DEFFINITION = 'UPDATE_BUSINESS_DEFFINITION';